(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-playlist/assets/javascripts/helpers/handlebar-helpers.js') >= 0) return;  svs.modules.push('/components/components/youtube-playlist/assets/javascripts/helpers/handlebar-helpers.js');

'use strict';

const { isServer } = svs;

const { splitTextWithUrl, truncateUrl, isUrl } = isServer ?
  require(`${__dirname}/utils.es6`) :
  svs.components.youtube_playlist.utils;

function registerHelpers(hbs) {
  hbs.registerHelper('isLessThan', function(v1, v2, options) {
    if (v1 < v2) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  hbs.registerHelper('parseLinks', function(text, maxLength = 30) {
    const parts = splitTextWithUrl(text);

    const processedParts = parts.map((part) => {
      if (isUrl(part)) {
        return `<a href="${part}" title="${part}">${truncateUrl(part, maxLength)}</a>`;
      }
      const replacedPart = part.replace(/\n\n/g, '<br>');
      return replacedPart;
    });

    const textWithLinkTags = new hbs.SafeString(processedParts.join(''));
    return textWithLinkTags;
  });
}

if (typeof exports === 'object') {
  registerHelpers(require('hbs'), true);
} else {
  registerHelpers(Handlebars, false);
}



 })(window);